export const dispatchTypeEnum = {
   DATA_FROM_SERVER: "DATA_FROM_SERVER",
   LOAD_USER_PLAYLISTS: "LOAD_USER_PLAYLISTS",
   LOAD_USER_LIKED_VIDEOS: "LOAD_USER_LIKED_VIDEOS",
   LOAD_USER_HISTORY: "LOAD_USER_HISTORY",
   TOGGLE_WATCH_LATER: "TOGGLE_WATCH_LATER",
   TOGGLE_LIKE: "TOGGLE_LIKE",
   ADD_NEW_PLAYLIST: "ADD_NEW_PLAYLIST",
   RENAME_PLAYLIST: "RENAME_PLAYLIST",
   DELETE_PLAYLIST: "DELETE_PLAYLIST",
   TOGGLE_VIDEO_IN_PLAYLIST: "TOGGLE_VIDEO_IN_PLAYLIST",
   ADD_TO_WATCH_HISTORY: "ADD_TO_WATCH_HISTORY",
   REMOVE_VIDEO_FROM_HISTORY: "REMOVE_VIDEO_FROM_HISTORY",
   CLEAR_HISTORY: "CLEAR_HISTORY",
   CLEAR_USER_DATA: "CLEAR_USER_DATA",
};

Object.freeze(dispatchTypeEnum);
